import React, { FC } from 'react';

import styles from './AppIcons.module.scss';

export const IconSmall: FC<{ imageUrl?: string }> = ({ imageUrl }) => {
    if (!imageUrl) return null;
    return <div className={styles.iconSmall} style={{ backgroundImage: `url(${imageUrl})` }}></div>;
};

export const IconMedium: FC<{ imageUrl?: string }> = ({ imageUrl }) => {
    if (!imageUrl) return null;
    return <div className={styles.iconMedium} style={{ backgroundImage: `url(${imageUrl})` }}></div>;
};
